export default __webpack_public_path__ + "static/media/cp_geo_yt.597e031d.svg";